import * as React from 'react';

import { MenuList } from '@coursera/cds-core';

import TranslationDropdownMenuItem from 'bundles/composable-page-header/legacy/translation/TranslationDropdownMenuItem';
import type { Language } from 'bundles/composable-page-header/legacy/translation/useCourseLanguageQuery';

type Props = {
  languages: Language[];
  currentLanguage: string;
};

const TranslationDropdownMenu = ({ languages, currentLanguage }: Props) => {
  if (languages.length === 0) {
    return null;
  }

  return (
    <MenuList>
      {languages.map((language) => (
        <TranslationDropdownMenuItem key={language.key} language={language} currentLanguage={currentLanguage} />
      ))}
    </MenuList>
  );
};

export default TranslationDropdownMenu;
